import React from 'react'
import { Svg } from '../../../..'

export const HomeInsuranceDefaultSvg = () => (
  <Svg width={192} height={86} viewBox='0 0 192 86' fill='none'>
    <path
      d='M191.22 41c0 33.5-77.981 44-131 44-53.02 0-73.937-12.5-51-44 37.5-51.5 55.98-25.5 108.999-25.5 53.02 0 73.001 6.5 73.001 25.5z'
      fill='#2D2B32'
      fillOpacity={0.5}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M126.043 31.258h-21.421v-1.82h21.788c.236 0 .461.095.627.266l9.259 9.5a.928.928 0 01.221.909.895.895 0 01-.676.628l-3.896.792a.875.875 0 01-.173.017h-27.15v-1.82h27.063l2.182-.444-7.824-8.028z'
      fill='#9D97AB'
    />
    <path d='M104.622 43.752h26.428V41.55h-26.428v2.202z' fill='#252328' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M105.306 40.449v35.67h26.162v-35.67h1.784v36.554a.888.888 0 01-.892.885h-27.946a.889.889 0 01-.893-.885V40.449h1.785z'
      fill='#9D97AB'
    />
    <path d='M61.678 30.539h41.843v-3.304H61.678v3.304z' fill='#252328' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M84.666 77c0-.552.456-1 1.017-1h45.967c.562 0 1.017.448 1.017 1s-.455 1-1.017 1H85.683a1.008 1.008 0 01-1.017-1z'
      fill='#9D97AB'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M60.577 27.007c0-.482.395-.873.883-.873h42.279c.488 0 .883.39.883.873v49.78h-1.767V27.88h-40.51v16.986h-1.768v-17.86z'
      fill='#9D97AB'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M82.05 2.127a.863.863 0 011.146 0L108.21 24.18l1.61 1.42c.37.326.413.899.096 1.279a.865.865 0 01-1.243.098l-1.609-1.42L82.623 4.01 56.526 27.017a.864.864 0 01-1.243-.099.925.925 0 01.096-1.278L82.05 2.127zM109.027 62.26c0-.491.368-.89.821-.89h7.167c.454 0 .821.399.821.89v14.739c0 .49-.367.889-.821.889h-7.167c-.453 0-.821-.398-.821-.89V62.26zm1.642.888V76.11h5.525V63.148h-5.525zM109.027 47.863c0-.446.359-.807.803-.807h5.002c.443 0 .802.361.802.807v7.194a.805.805 0 01-.802.808h-5.002a.805.805 0 01-.803-.808v-7.194zm1.605.808v5.578h3.397v-5.578h-3.397zM85.903 33.65c0-.502.375-.91.837-.91H97.18c.462 0 .837.407.837.91v8.092c0 .502-.375.909-.838.909H86.74c-.462 0-.837-.407-.837-.909V33.65zm1.674.908v6.276h8.764v-6.276h-8.764zM92.611 47.879c0-.455.36-.823.804-.823h3.797c.444 0 .804.368.804.823v7.162c0 .455-.36.824-.804.824h-.7a.814.814 0 01-.803-.824c0-.418.304-.763.699-.816v-5.523h-2.993a.814.814 0 01-.804-.823zM95.273 62.194c0-.455.428-.823.956-.823h.831c.528 0 .956.368.956.823v7.162c0 .455-.428.824-.956.824h-2.493c-.528 0-.956-.369-.956-.824 0-.454.428-.823.956-.823h1.538V63.01c-.47-.052-.832-.398-.832-.816zM67.184 33.667a.93.93 0 01.932-.926h11.35a.93.93 0 01.931.926v8.058a.93.93 0 01-.931.926.93.93 0 01-.932-.926v-7.132h-9.486v5.972a.93.93 0 01-.932.927.93.93 0 01-.932-.927v-6.898zM120.039 47.863c0-.446.419-.807.936-.807h5.836c.517 0 .936.361.936.807v7.194c0 .446-.419.808-.936.808h-5.836c-.517 0-.936-.362-.936-.808v-7.194zm1.872.808v5.578h3.964v-5.578h-3.964z'
      fill='#9D97AB'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M72.884 41.586a.782.782 0 01.886.001l1.885 1.3h.002a12.09 12.09 0 004.361 1.849c1.572.323 3.193.323 4.765 0l2.541-.55a.785.785 0 01.875.432l1.129 2.369c4.547 9.532 4.38 20.532-.56 28.023-1.525 2.31-5.56 7.583-12.089 10.094a.717.717 0 01-.047.017l-2.326.73-.007.002a3.4 3.4 0 01-1.981 0l-.007-.003-2.32-.73a.699.699 0 01-.046-.016c-6.528-2.511-10.562-7.784-12.088-10.093-4.977-7.493-5.107-18.494-.568-27.996v-.001l1.136-2.394a.785.785 0 01.874-.434l2.555.55c1.573.323 3.194.323 4.766 0 1.56-.322 3.043-.95 4.362-1.85l1.902-1.3zm.44 1.613l-1.458.998h-.001a13.658 13.658 0 01-4.93 2.09 13.422 13.422 0 01-5.399 0l-.007-.002-1.952-.42-.868 1.833-.001.002c-4.356 9.118-4.144 19.505.458 26.432l.001.002c1.457 2.206 5.256 7.143 11.317 9.483l2.29.72.003.001c.347.105.717.105 1.064 0l.003-.001 2.296-.72c6.061-2.34 9.86-7.276 11.317-9.483 4.57-6.929 4.815-17.318.453-26.462l-.861-1.806-1.94.42-.007.001a13.422 13.422 0 01-5.399 0 13.658 13.658 0 01-4.93-2.09l-.003-.002-1.446-.996z'
      fill='#F3EFF1'
    />
    <path
      d='M85.726 48.89a16.27 16.27 0 01-12.406-2.491 16.274 16.274 0 01-12.447 2.49c-4.093 8.579-3.761 17.883.298 23.999.691 1.058 4.93 7.34 12.136 9.152 7.205-1.813 11.437-8.094 12.135-9.152 4.06-6.116 4.391-15.42.284-23.999z'
      fill='#F3EFF1'
      fillOpacity={0.1}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M80.406 58.43c.356.255.43.74.168 1.083l-8.658 11.323a.817.817 0 01-1.21.088l-4.59-4.43a.756.756 0 01-.001-1.094.82.82 0 011.132-.001l3.933 3.795 8.106-10.6a.82.82 0 011.12-.163z'
      fill='#F3EFF1'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M87.228 1.122a.95.95 0 011.31-.098l19.064 15.82a.88.88 0 01.1 1.268.95.95 0 01-1.309.097L87.329 2.39a.88.88 0 01-.1-1.267z'
      fill='#9D97AB'
    />
    <path
      d='M111.229 20.648a1.098 1.098 0 00-1.296-1.104 1.103 1.103 0 00-.83 1.486 1.104 1.104 0 002.037.039c.057-.133.088-.276.089-.421z'
      fill='#9D97AB'
    />
  </Svg>
)

export default HomeInsuranceDefaultSvg
